export default Alpine.data('googleMapsAutocomplete', (livewireInstance) => {
    return {
        search: '',
        async init() {
            await google.maps.importLibrary("places");

            const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({id: 'autocomplete-input'});

            this.$refs.autocomplete.appendChild(placeAutocomplete);

            const selectedPlaceTitle = document.createElement('p');
            selectedPlaceTitle.textContent = '';
            this.$refs.autocomplete.appendChild(selectedPlaceTitle);
            const selectedPlaceInfo = document.createElement('pre');
            selectedPlaceInfo.textContent = '';
            this.$refs.autocomplete.appendChild(selectedPlaceInfo);

            placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
                const place = placePrediction.toPlace();
                await place.fetchFields({ fields: ['postalAddress', 'formattedAddress', 'location'] });

                livewireInstance.updateAddress(place.id, place.postalAddress, place.formattedAddress, place.location.lat(), place.location.lng());
            });
        },
    }
});
